import {
    ADD_LEVEL,
    EMPTY_ANSWER,
    EMPTY_LEVEL,
    REMOVE_LEVEL,
    SELECT_ANSWER,
    UPDATE_LEVEL
} from "../../constants/actionTypes";

const initialState = { levels: [], answers: {}, loading: false, error: null };

const interactiveEducation = (state = initialState, action) => {
    switch (action.type) {
        case ADD_LEVEL:
            return { ...state, levels: [...state.levels, ...action.payload] };
        case UPDATE_LEVEL:
            const levels = [...state.levels];
            const levelIndex = levels.findIndex(level => level.id === action.payload.id);
            levels[levelIndex] = { ...action.payload };
            return { ...state, levels: [...levels] };
        case REMOVE_LEVEL:
            return { ...state, levels: state.levels.filter(level => level.id !== action.payload) };
        case EMPTY_LEVEL:
            return { ...state, levels: [] };
        case SELECT_ANSWER:
            return { ...state, answers: { ...state.answers, [action.payload.step]: action.payload.index } };
        case EMPTY_ANSWER:
            return { ...state, answers: {} };
        default:
            return state;
    }
};

export default interactiveEducation;
